/**
 * !!! AUTOGENERATED, DO NOT MODIFY !!!
 *
 * This file is generated by dashboard/script/remote_lookup/generate_remote_lookup_schemas.rb
 * Because the generation script depends on rails, generation is run manually and the file is checked in.
 * Please do not edit manually.
 *
 * To regenerate, run:
 *   yarn remote-lookup:update-generated-schemas
 *
 * @owner @Appboy/messaging-experience
 */

import { z } from "zod";
import { common } from "../common";

// Our zod-to-typescript generation tooling demands an export that matches the module name.
export const canvasStepRemoteLookupSchema = z.any();

export const canvasStepRemoteLookupIdSchema = z.object({ canvas_id: common.objectId, step_id: common.objectId });

export const canvasStepRemoteLookupItemSchema = z.object({
  canvas_id: common.objectId,
  step_id: common.objectId,
  name: z.string().nullable(),
  is_archived: z.boolean(),
});

export const canvasStepRemoteLookupFiltersSchema = z.object({
  canvas_id: common.objectId.nullable().nullable().optional(),
  step_type: z.enum(["MESSAGE"]).nullable().nullable().optional(),
});

export const canvasStepRemoteLookupValidators = {
  id: canvasStepRemoteLookupIdSchema,
  item: canvasStepRemoteLookupItemSchema,
  filters: canvasStepRemoteLookupFiltersSchema,
};

/* rails_test_output_hash: 8aa80f09f8e30bf918a969385c9a7023 */
